module.exports = __webpack_public_path__ + "img/kec_image.5a5abe11.png";